import { IPreloadedState } from 'shared/types/redux';

export const selectHouseId = (state: IPreloadedState) => state.houseInfo.id;
